// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"93d21c37","453":"ba96065e","732":"02c5e4b4"}[chunkId] + ".chunk.js";
};